import * as React from "react";
import CountUp from 'react-countup';
import Skeleton from 'react-loading-skeleton';
import { FilterParams, FilterContextType, compareFilterCtxEqual } from "./context/filter";
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { Chart, Point, CommonSeriesSettings, Tooltip, CommonAxisSettings, Tick, Legend, Pane, LoadingIndicator, Grid, ValueAxis, Size } from 'devextreme-react/chart'

interface StatisticChartProps<Params = any> {
    style?: React.CSSProperties;
    subtitle?: string;
    additionalParams?: Params;
    onRequestLoad: (params: FilterParams, abortSignal: AbortSignal) => Promise<{
        total: number;
        data: {}[];
    }>;
}

export class StatisicChart<Params = any> extends React.Component<StatisticChartProps<Params>, { value?: number }> {

    static contextType = FilterContextType

    previousContext: FilterParams;
    context: FilterParams

    private store: CustomStore;
    private dataSource: DataSource;
    chart: Chart | null;

    private abortController = new AbortController()

    constructor(p: any) {
        super(p);
        this.state = {
        }
        this.store = new CustomStore({
            load: () => {
                this.abortController.abort()
                this.abortController = new AbortController()
                return this.props.onRequestLoad({ ...this.context, ...this.props.additionalParams } as FilterParams & Params, this.abortController.signal).then(({ total, data }) => {
                    this.setState({ value: total })
                    return data
                })
            }
        });
        this.dataSource = new DataSource({ store: this.store })
    }

    componentDidUpdate(prevProps: StatisticChartProps) {
        if (!compareFilterCtxEqual(this.previousContext, this.context)) {
            this.loadData();
        } else if (Boolean(this.props.additionalParams) != Boolean(prevProps.additionalParams)) {
            console.log(`${this.props.subtitle} is loading data cause adiitionalParams is no equal`)
            this.loadData()
        } else if (this.props.additionalParams) {
            let simpleNotEqual = Object.keys(this.props.additionalParams).find(k => {
                if (prevProps.additionalParams) {
                    return prevProps.additionalParams[k] != this.props.additionalParams![k]
                } else {
                    return true
                }
            }) != undefined
            if (simpleNotEqual) {
                console.log(`${this.props.subtitle} is loading data cause adiitionalParams is no equal (2)`)
                this.loadData()
            }
        }
        this.previousContext = this.context;
    }

    componentDidMount() {
        this.previousContext = this.context;
    }

    componentWillUnmount() {
        this.abortController.abort()
    }

    loadData() {
        this.setState({ value: undefined })
        this.dataSource.reload()
        this.chart!.instance.showLoadingIndicator()
    }

    render() {
        const { style, subtitle } = this.props
        const { value } = this.state
        return <div className='statistic chart' style={style}>
            <div className='statistic-container' style={style}>
                <div className='stat-conainer'>
                    <div className='value'>{(value == undefined) ? <Skeleton width={80} /> : <CountUp end={typeof value == 'string' ? parseInt(value) : value} duration={1.5} useEasing />}</div>
                    <div className='title'>{subtitle}</div>
                </div>
                <div className='chart-conainer'>
                    <Chart ref={(ref) => this.chart = ref} dataSource={this.dataSource}>
                        {this.props.children}
                        <Size height={100} />
                        <CommonSeriesSettings type='spline'>
                            <Point size={0} hoverStyle={{ size: 8, color: 'var(--platform)', border: { color: '#fff', width: 4 } }}
                                hoverMode='onlyPoint' />
                        </CommonSeriesSettings>
                        <CommonAxisSettings valueMarginsEnabled={false} allowDecimals={false} visible={false}>
                            <Tick visible={false} />
                            <Grid visible={false} />
                        </CommonAxisSettings>
                        <ValueAxis label={{ visible: false }} />
                        <Legend visible={false} />
                        <Pane border={{ visible: false }} />
                        <Tooltip enabled color='#fff' font={{ color: '#000' }} arrowLength={8} />
                        <LoadingIndicator enabled defaultShow />

                    </Chart>
                </div>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/StatisticChart.tsx